import React from "react";
import { ButtonTypes } from "../../shared-components/Button";
import { ButtonColorTypes } from "../../shared-components/Button";
import Button from "../../shared-components/Button";

type Props = {
  canAddReport: boolean;
  navigateCreatePerson: () => void;
};

export function CanAddReportButton({
  canAddReport,
  navigateCreatePerson,
}: Props) {
  if (!canAddReport) {
    return <></>;
  }
  return (
    <Button
      type={ButtonTypes.add}
      text="Add New Report"
      colorType={ButtonColorTypes.success}
      onClick={() => navigateCreatePerson()}
    />
  );
}
